<template>
  <UiSectionWrapper
    title="Biar Bisnismu Nggak Tersendat, Cairkan Dana COD Sekarang!"
    sub-title="COD Cair Cepat"
    description="Dengan KiriminAja, pencairan dana COD jadi cepat, transparan, dan otomatis.Nikmati cashflow lancar dan pertumbuhan bisnis tanpa hambatan."
    hero-image="/images/cod-cair-cepat-banner-3.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
    button-label="Cairkan Dana COD Sekarang"
    :button-link="
      $utm.utmUrl('/login', {
        redirectTo: '/balance-mutation'
      })
    "
  />
</template>
